import * as fastDeepEqual from 'fast-deep-equal';

export type EqualFunction<A, B> = (a: A, b: B) => boolean;

export class FastDeepEqual {
  public static default<A, B>(): EqualFunction<A, B> {
    return (fastDeepEqual as any)['default'] ? (fastDeepEqual as any)['default'] : fastDeepEqual;
  }
}
